import { ChangeDetectorRef, Directive, OnDestroy, OnInit, ViewRef, inject } from '@angular/core';
import { App } from '@df/core/app';
import { TimeoutService } from '@df/ng/timeout.service';
import { WishlistItem } from '@df/session/api/wishlist/wishlist-item';
import { Subscription } from 'rxjs';

@Directive()
export abstract class AccountWishlistComponentDef implements OnInit, OnDestroy {
    protected subscriptions: Subscription = new Subscription();

    /**
     * App accecss
     */
    protected app = inject(App);

    protected timeoutService = inject(TimeoutService);

    /**
     * Wishlist access
     */
    get wishlist() {
        return this.app.customer.wishlist;
    }

    /**
     * Class constructor
     */
    constructor(protected _ref: ChangeDetectorRef) {}

    /**
     * On init hook
     */
    ngOnInit() {
        this.subscriptions.add(this.wishlist.wishlistUpdateSubject.subscribe(() => this.detectChanges()));
    }

    /**
     * On destroy hook
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Tracking function
     */
    itemTrackFn(index: number, item: WishlistItem): number {
        return item.data.id;
    }

    protected detectChanges() {
        this.timeoutService.async(() => {
            if (!(<ViewRef>this._ref).destroyed) {
                this._ref.detectChanges();
            }
        });
    }
}
